export default {
  state: {
    items: [
      {
        name: "about_ios_develop",
        filter: "ios",
        imageLink:
          "https://file.ilook.su/public/AppInfo/images/banner_apple.jpg",
        title: "iOS & tvOS",
        subtitle: "Swift, Flutter",
        text: "",
      },
      {
        name: "about_android_develop",
        filter: "android",
        imageLink:
          "https://file.ilook.su/public/AppInfo/images/banner_android.jpg",
        title: "Android + TV",
        subtitle: "Kotlin, Flutter",
        text: "",
      },
      {
        name: "about_node_develop",
        filter: "server",
        imageLink:
          "https://file.ilook.su/public/AppInfo/images/banner_node.jpg",
        title: "Server API",
        subtitle: "NodeJS",
        text: "",
      },
    ],
  },
  getters: {
    getBanners(state) {
      return state.items;
    },
  },
  mutations: {
    updateBanners(state, payload) {
      state.items[0].text = payload[0];
      state.items[1].text = payload[1];
      state.items[2].text = payload[2];
    },
  },
  actions: {},
};
